module.exports = __webpack_public_path__ + "03d9c4d186f9d11569887c0c25c5561b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_green.png
// module id = 72
// module chunks = 0 1 2 3 4